<ng-content select="[xpDetailLayoutSide]"></ng-content>
<ng-content></ng-content>
